<template>
<div class="login-box">
    <div class="container">
        <div class="columns is-centered">
            <div class="column is-4 has-text-centered login-container">
                <h1>TZ Austria</h1>
                <div>{{ $t("login-detail") }}
                    <br>
                    <form @submit.prevent="validateBeforeSubmit">
                        <b-field :label="$t('username')"
                            :type="{'is-danger': errors.has('username')}"
                            :message="errors.first('username')">
                            <b-input type="text" v-model="user.username" name="username" v-validate="'required'" />
                        </b-field>

                        <b-field :label="$t('password')"
                            :type="{'is-danger': errors.has('password')}"
                            :message="errors.first('password')">
                            <b-input type="password" v-model="user.password" name="password" v-validate="'required|min:8'" />
                        </b-field><br>

                        <button type="submit" class="button is-primary"> {{ $t("login") }} </button>
                        <button @click="loginAsGuest" class="button is-light" style="margin-left: 2em">{{ $t("login-as-guest") }}</button><br><br>
                    </form>
                    <router-link to="/forgot-password">{{ $t("password-forgotten") }}</router-link><br><br>
                    <p>{{ $t("not-yet-registered") }}</p>
                    <router-link to="/register">{{ $t("create-new-account") }}</router-link>
                </div>
            </div>
            <b-loading :is-full-page="false" :active.sync="getLoginActive">
            </b-loading>
        </div>
    </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'LoginBox',
    data: function(){
        return {
            user:{
                username: '',
                password: '',
            },
        }
    },
    computed: {
        ...mapGetters (["getLoginActive"])
    },
    methods: {
        validateBeforeSubmit() {
            var self=this
                this.$validator.validateAll ().then ((result) => {
                    if (result) {
                        this.$store.dispatch ("login",{user:this.user,self:self})
                        .catch((error) => {
                            self.$toastr('error', error, 'Failure')
                    })
                }
            })
        }, loginAsGuest(evt) {
            var self=this
            evt.stopPropagation ()
            evt.preventDefault  ()
            this.$store.dispatch ("login",{user:{username: "w-guest@tzaustria.at", password:"Guest@Wuerth"},self:self})
                        .catch((error) => {
                            self.$toastr('error', error, 'Failure')
                        })
        }
    }
}
</script>

<style>
.login-container{
  background-color: #fff;
  font-color:#000;
  padding-left:35px;
  padding-right:35px;
  padding-top:35px;
  padding-bottom: 35px;
}

</style>